import { render, staticRenderFns } from "./movie-detail.vue?vue&type=template&id=5cfba9b8&scoped=true"
import script from "./movie-detail.vue?vue&type=script&lang=js"
export * from "./movie-detail.vue?vue&type=script&lang=js"
import style0 from "./movie-detail.vue?vue&type=style&index=0&id=5cfba9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfba9b8",
  null
  
)

export default component.exports